import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { toMoney } from "../../../../../../utils/formatter";
import { useDispatch, useSelector } from "react-redux";
import { importSelectedFilter } from "../../../../../../redux/actions/dashboard";
require("./RoundedBarsHolding.js");

const BarChartTotalHolding = ({ labels, data, color, isToPay }) => {


  let errColor;
  let selectedColor = '#9743F2';
  let due = '#EAB308';

  let datasets = [{}];
  data?.forEach((element) => {
    datasets = [
      {
        data: [
          element.valid < 0 ? element.valid * -1 : element.valid,
          element.expired30 < 0 ? element.expired30 * -1 : element.expired30,
          element.expired60 < 0 ? element.expired60 * -1 : element.expired60,
          element.expired90 < 0 ? element.expired90 * -1 : element.expired90,
          element.expiredOlder < 0
            ? element.expiredOlder * -1
            : element.expiredOlder,
        ],
        backgroundColor: [
          element.valid < 0 ? errColor : color,
          element.expired30 < 0 ? errColor : element.barSelected.status && element.barSelected.bar === '1, 30' ? selectedColor : due,
          element.expired60 < 0 ? errColor : element.barSelected.status && element.barSelected.bar === '31, 60' ? selectedColor : due,
          element.expired90 < 0 ? errColor : element.barSelected.status && element.barSelected.bar === '61, 90' ? selectedColor : due,
          element.expiredOlder < 0 ? errColor : element.barSelected.status && element.barSelected.bar === '91' ? selectedColor : due,
        ],
      },
    ];
  });

  return (
    <div style={{ position: "relative" }}>
      <Bar
        data={{
          labels: labels,
          datasets: datasets,
          borderWidth: 1,
          legend: true,
        }}
        height={140}
        width={500}
        options={{
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                let result =
                  data.datasets[0].backgroundColor[tooltipItem.index] ===
                    errColor
                    ? toMoney(tooltipItem.value * -1)
                    : toMoney(tooltipItem.value);
                return result;
              },
              footer: function (tooltipItem, data) {
                let result =
                  data.datasets[0].backgroundColor[tooltipItem[0].index] ===
                    errColor
                    ? "Hay notas de crédito no asociadas"
                    : null;
                return result;
              },
            },
            displayColors: false,
          },
          cornerRadius: 8,
          responsive: true,
          legend: {
            display: false,
          },
          title: {
            display: false,
            text: "Cobranza (1.000.000 = 1 MM)",
            position: "top",
            align: "end",
            fontSize: 12,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  source: "labels",
                  padding: 8,
                  fontSize: 13,
                  callback: (value, index, values) => {
                    let sup = ''
                    let inf = ''
                    if (value === "Al día") sup = value
                    else {
                      sup = value.slice(0, 14)
                      inf = value.slice(14)
                    }
                    return [sup, inf];
                  }
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  display: true,
                  labelOffset: 1,
                  callback(value, index) {
                    if (index % 2 === 0) return "";
                    if (
                      data[0].valid === 0 &&
                      data[0].expired30 === 0 &&
                      data[0].expired60 === 0 &&
                      data[0].expired90 === 0 &&
                      data[0].expiredOlder === 0
                    )
                      return "0 MM";
                    if (index % 2 !== 0) return `${value / 1000000} MM`;
                    return data[0].nameToShow !== undefined
                      ? `${value / 1000000} MM`
                      : "0 MM";
                  },
                },
                gridLines: {
                  display: true,
                },
              },
            ],
          },
        }}
      />
      {/* <span style={{
        position: "absolute",
        top: "0px",
        right: "10px",
        fontSize: "12px",
        color: "#666",
      }}>
        Cobranza (1.000.000 = 1 MM)
      </span> */}
    </div>
  );
};

export default BarChartTotalHolding;
